import 'whatwg-fetch';
const API_URL = '/wp-admin/admin-ajax.php';

class API {

    sendInquiry(data) {
        return new Promise( async (resolve, reject) => {
            try {
                const response = await fetch(`${window.location.origin}${API_URL}`, 
                    {
                        method: 'POST', 
                        headers: new Headers(
                            {'Content-Type': 'application/x-www-form-urlencoded;'},
                            {'Accept': 'application/json, application/xml, text/plain, text/html, *.*'}
                        ),
                        credentials: 'same-origin',
                        body: data, 
                    });
                const json = await response.json();
                resolve(json);
            } catch(error) {
                reject(error);
            }
        }) 
        
    }
}

const api = new API();
export default api;


// WEBPACK FOOTER //
// ./src/servics/api.js